import { accounts_data_of_type, IFieldsData } from './accounts-data-model';

export class AccountDetailsProvider {
    private fieldsDataDefault: IFieldsData = {
        account_type: 'default_account',
        label_account_id: 'Identificación de la cuenta',
        account_detail_type: [],
        bank_name_required: false,
        identification: false,
        placeholder_identification: '',
        label_identification: ''
    };

    public getFieldsData(accountType: string): IFieldsData {
        let fieldsData: IFieldsData | undefined = accounts_data_of_type.find(
            (account: IFieldsData): boolean => account.account_type === accountType
        );

        return fieldsData ?? this.fieldsDataDefault;
    }
}
